module.exports = __webpack_public_path__ + "media/escape.c2e99fa3.wav";